module.exports = __webpack_public_path__ + "img/network-protection.b18bc323.png";